import * as Yup from "yup";

const schema = Yup.object().shape({
  percentage: Yup.string().optional(),
  year_obtained: Yup.string().optional(),
  country_obtained: Yup.string().optional(),
  communicate_at: Yup.string().optional(),
  message: Yup.string().optional(),
  year_obtaining_certificate: Yup.string().optional(),
  country_obtaining_certificate: Yup.string().optional(),
});

export default schema;
